import React, { useState, useEffect, memo } from 'react';
import AxiosServices from '../../services/AxiosServices';
import OrdersStatusSelector from './OrdersStatusSelector';
import Loader from '../../ui/Loader';
import DataTable from './DataTable';
import orderBy from 'lodash.orderby';
import Singleton from '../../core/singleton';
import events from '../../core/events';

const Orders = () => {
    const { eventEmitter } = Singleton.getInstance();
    const [baseOrders, setBaseOrders] = useState([]);
    const [displayedOrders, setDisplayedOrders] = useState([]);
    const [pending, setPending] = useState(false);
    const [ordersWorkflow, setOrdersWorkflow] = useState({
        transitions: []
    });
    const statusList = [
        "paid",
        "paid_on_delivery",
        "canceled",
        "delivered",
        "delivering",
        "to_refund",
        "refunded"
    ]
    /** ajax call for getting all the orders */
    const getOrders = () => {
        setPending(true);
        AxiosServices.ordersWorkflow().then(workflow => {
            setOrdersWorkflow(workflow.data);
            return AxiosServices.orders()
                .then(result => {
                    let s = orderBy(result.data, ['created_at'], 'desc').filter((e) => (statusList.includes(e.status)));
                    setBaseOrders(s);
                    setDisplayedOrders(s);
                    setPending(false);
                })
        }).catch(error => {
            (error.response.status === 401) &&
                eventEmitter.emit(events.ON_USER_LOGOUT);
        })

    }
    /** when the status change */
    const onStatusChange = link => {
        setDisplayedOrders(link.orders);
    }
    /** when a click occur on the filter btn */
    const onSortBy = header => {
        let s = orderBy(displayedOrders, [header.label], header.dir);
        setDisplayedOrders(s);
    };
    /** component did mount like */
    useEffect(() => getOrders(), []);
    return <div className="container-fluid">
        {
            (pending) &&
            <Loader />
        }
        <h4 className="text-center text-md-right form-group">Manage Orders <button onClick={() => getOrders()} className="btn btn-outline-primary"><i className="fas fa-sync-alt" /></button></h4>
        <div className="row align-items-center form-group">
            <OrdersStatusSelector onStatusChange={link => onStatusChange(link)} baseOrders={baseOrders} />
        </div>
        <DataTable refresh={() => getOrders()} sortBy={header => onSortBy(header)} displayedOrders={displayedOrders} ordersWorkflow={ordersWorkflow} />
    </div>
}
export default memo(Orders)